// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hiogpjqlwlvrlhxobwmi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhpb2dwanFsd2x2cmxoeG9id21pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4MjczNTAsImV4cCI6MjA1MDQwMzM1MH0.WAeiYcAX3fC8zNULf4BjbH3qq0wqmq54TV9sQRp_VLU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);